<template>
  <div class="dialog">
    <el-dialog :title="studentInfo.gradeName + studentInfo.className + studentInfo.studentName + '的行为记录'"
      :visible.sync="studentExperienceDialogShow" width="1000px" :before-close="dialogClose" @open="dialogOpen">
      <!-- 学年学期 -->
      <!-- <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" label-position="top"
        :inline="true">
      </el-form>
      <div class="form-btn">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div> -->
      <div class="visit-form-container">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="学年" prop="commMethod">
                <!-- <el-date-picker style="width: 150px" v-model="ruleForm.schoolYear" type="year" value-format="yyyy"
                  placeholder="请选择学年" @change="selectStudentBehaviorList">
                </el-date-picker> -->
                <year-range-picker style="width: 250px;" v-model="ruleForm.schoolYear"
                  @change="selectStudentBehaviorList" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="学期" prop="interviewTime">
                <el-select v-model="ruleForm.semester" placeholder="请选择学期" style="width: 150px"
                  @change="selectStudentBehaviorList">
                  <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
                    :value="item.dictValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label="班主任" prop="interviewAddress">
                <el-select v-model="ruleForm.classTeacher" placeholder="请选择班主任" style="width: 150px">
                  <el-option v-for="(item, index) in classTeacherList" :key="index" :label="item.teacherName"
                    :value="item.teacherId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>-->

            <!-- <el-col :span="6">
              <el-form-item label="导师" prop="studentName">
                <el-select v-model="ruleForm.studentSupervisor" multiple placeholder="请选择导师" style="width: 150px">
                  <el-option v-for="item in studentSupervisorList" :key="item.teacherId" :label="item.teacherName"
                    :value="item.teacherId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </div>
      <!-- 列表表格 -->
      <div class="table-container">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="recordTime" label="日期">
          </el-table-column>
          <el-table-column prop="tutorName" label="导师姓名">
          </el-table-column>
          <el-table-column prop="teacherChargeName" label="班主任姓名">
          </el-table-column>
          <el-table-column label="操作" width="160px">
            <template slot-scope="scope">
              <div class="handle-container">
                <el-button type="warning" size="small" @click="editClick(scope.row)" v-hasPermi="'sc:studentrecord_stu:edit'">修改
                </el-button>
                <el-button type="danger" size="small" @click="delClick(scope.row)" v-hasPermi="'sc:studentrecord_stu:delete'">删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 添加 -->
      <div class="form-btn">
        <el-button type="primary" @click="addClick" v-hasPermi="'sc:studentrecord_stu:add'">添加</el-button>
      </div>
      <!-- 添加弹窗 -->
      <el-dialog width="1000px" title="添加" @open="addDialogOpen" @dialog-close="addDialogClose"
        :visible.sync="addStudentBehaviorDialogShow" append-to-body>
        <!-- 学年学期 -->
        <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="100px" class="ruleForm"
          label-position="right">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="学年" prop="schoolYear">
                <!-- <el-date-picker style="width: 235px" v-model="addForm.schoolYear" type="year" value-format="yyyy"
                  placeholder="请选择学年">
                </el-date-picker> -->
                <year-range-picker style="width: 250px;" v-model="addForm.schoolYear" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="学期" prop="semester" style="margin-left: 80px;">
                <el-select v-model="addForm.semester" placeholder="请选择学期" style="width: 235px;">
                  <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
                    :value="item.dictValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="班主任" prop="teacherChargeId">
                <el-select v-model="addForm.teacherChargeId" placeholder="请选择班主任" style="width: 150px">
                  <el-option v-for="(item, index) in classTeacherList" :key="index" :label="item.teacherName"
                    :value="item.teacherId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="导师" prop="tutorId">
                <el-select v-model="addForm.tutorId" placeholder="请选择导师" style="width: 150px">
                  <el-option v-for="item in studentSupervisorList" :key="item.teacherId" :label="item.teacherName"
                    :value="item.teacherId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="记录时间" prop="recordTime">
                <el-date-picker style="width: 235px" v-model="addForm.recordTime" type="date" value-format="yyyy-MM-dd"
                  placeholder="请选择时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="奖惩情况" prop="recordContent">
            <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8 }" v-model="addForm.recordContent"
              :maxlength="maxlength" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div class="form-btn">
          <el-button type="primary" @click="addStudentBehaviorDialogShow = false">返回</el-button>
          <el-button type="primary" @click="addSubmit">确认</el-button>
        </div>
      </el-dialog>
      <!-- 修改弹窗 -->
      <el-dialog width="1000px" title="修改" :visible.sync="editStudentBehaviorDialogShow" append-to-body>
        <!-- 学年学期 -->
        <el-form :model="editData" :rules="addRules" ref="editForm" label-width="100px" class="ruleForm"
          label-position="right">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="学年" prop="schoolYear">
                <!-- <el-date-picker style="width: 235px" v-model="editData.schoolYear" type="year" value-format="yyyy"
                  placeholder="请选择学年">
                </el-date-picker> -->
                <year-range-picker style="width: 250px;" v-model="editData.schoolYear" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="学期" prop="semester" style="margin-left: 80px;">
                <el-select v-model="editData.semester" placeholder="请选择学期" style="width: 235px;">
                  <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
                    :value="item.dictValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="班主任" prop="teacherChargeId">
                <el-select v-model="editData.teacherChargeId" placeholder="请选择班主任" style="width: 150px">
                  <el-option v-for="(item, index) in classTeacherList" :key="index" :label="item.teacherName"
                    :value="item.teacherId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="导师" prop="tutorId">
                <el-select v-model="editData.tutorId" placeholder="请选择导师" style="width: 150px">
                  <el-option v-for="item in studentSupervisorList" :key="item.teacherId" :label="item.teacherName"
                    :value="item.teacherId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="记录时间" prop="recordTime">
                <el-date-picker style="width: 235px" v-model="editData.recordTime" type="date" value-format="yyyy-MM-dd"
                  placeholder="请选择时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="奖惩情况" prop="recordContent">
            <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8 }" v-model="editData.recordContent"
              :maxlength="maxlength" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div class="form-btn">
          <el-button type="primary" @click="editStudentBehaviorDialogShow = false">返回</el-button>
          <el-button type="primary" @click="editSubmit">确认</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'semesterOptions',
    'studentExperienceDialogShow',
    'studentInfo',
    'classTeacherList',
    'studentSupervisorList'
  ],
  data() {
    return {
      maxlength: 1000,
      ruleForm: {
        schoolYear: "",
        semester: "",
        classTeacher: "",
        studentSupervisor: "",
      },
      rules: {
        schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
        semester: [{ required: true, message: "请选择学期", trigger: "change" }],
        classTeacher: [{ required: true, message: "请选择班主任", trigger: "change" }],
        studentSupervisor: [{ required: true, message: "请选择导师", trigger: "change" }],
      },
      addForm: {
        schoolYear: "",
        semester: "",
        teacherChargeId: "",
        tutorId: "",
        recordTime: "",
        recordContent: "",
      },
      addRules: {
        schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
        semester: [{ required: true, message: "请选择学期", trigger: "change" }],
        teacherChargeId: [{ required: true, message: "请选择班主任", trigger: "change" }],
        tutorId: [{ required: true, message: "请选择导师", trigger: "change" }],
        recordTime: [{ required: true, message: "请选择时间", trigger: "change" }],
        recordContent: [{ required: true, message: "请输入行为内容", trigger: "blur" }],
      },
      tableData: [], // 列表数据
      addStudentBehaviorDialogShow: false, // 添加学生行为记录弹窗
      editStudentBehaviorDialogShow: false, // 修改学生行为记录弹窗
      editData: {},
    };
  },
  mounted() {
    this.ruleForm = {
      schoolYear: this.school.schoolYear,
      semester: this.school.semester,
      classTeacher: "",
      studentSupervisor: "",
    };
    this.selectStudentBehaviorList();
  },
  methods: {
    addClick() {
      this.addStudentBehaviorDialogShow = true
    },
    editClick(row) {
      this.editData = row;
      this.editStudentBehaviorDialogShow = true;
    },
    editSubmit() {
      this.$refs["editForm"].validate((valid) => {
        if (!valid) return;
        let data = {
          ...this.editData,
          "gradeName": this.studentInfo.gradeName,
          "teacherChargeName": this.classTeacherList.find(item => item.teacherId === this.editData.teacherChargeId).teacherName,
          "tutorName": this.studentSupervisorList.find(item => item.teacherId === this.editData.tutorId).teacherName,
        };
        this.put(this.$url.editStudentBehavior, data).then((res) => {
          if (res.code !== 200) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.editStudentBehaviorDialogShow = false;
          this.selectStudentBehaviorList();
        })
      })
    },
    addSubmit() {
      this.$refs["addForm"].validate((valid) => {
        if (!valid) return;
        // console.log(this.addForm);
        let data = {
          ...this.addForm,
          "schoolId": this.school.id,
          "schoolName": this.school.schoolName,
          "gradeId": this.studentInfo.gradeId,
          "gradeName": this.studentInfo.gradeName,
          "classId": this.studentInfo.classId,
          "className": this.studentInfo.className,
          "teacherChargeName": this.classTeacherList.find(item => item.teacherId === this.addForm.teacherChargeId).teacherName,
          "tutorName": this.studentSupervisorList.find(item => item.teacherId === this.addForm.tutorId).teacherName,
          "studentId": this.studentInfo.id,
          "studentName": this.studentInfo.studentName,
        };
        this.post(this.$url.insertStudentBehavior, data).then((res) => {
          if (res.code !== 200) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.addStudentBehaviorDialogShow = false;
          this.selectStudentBehaviorList();
        })
      })
    },
    addDialogOpen() {
      this.addForm = {
        schoolYear: this.school.schoolYear,
        semester: this.school.semester,
        teacherChargeName: "",
        tutorName: "",
        recordTime: "",
        recordContent: "",
      };
    },
    addDialogClose() {
      this.addForm = {
        schoolYear: "",
        semester: "",
        teacherChargeName: "",
        tutorName: "",
        recordTime: "",
        recordContent: "",
      };
      this.$refs["addForm"].clearValidate(); //移除表单检验结果
    },
    delClick(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delete(this.$url.deleteStudentBehavior + "?id=" + row.id).then((res) => {
            if (res.code !== 200) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.selectStudentBehaviorList();
          })
        })
    },
    // 开启弹窗
    dialogOpen() {

    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:studentExperienceDialogShow", false);
    },
    confirm() {
    },
    schoolYearChangeHandle(e) {

    },
    // 学生行为记录列表
    selectStudentBehaviorList() {
      let data = {
        studentId: this.studentInfo.id,
        schoolYear: this.ruleForm.schoolYear,
        semester: this.ruleForm.semester,
        // recordTime: this.searchData.interviewTime,
        // pageNum: this.pageInfo.pageNum,
        // pageSize: this.pageInfo.pageSize,
        // teacherId: this.teacherId
      };
      this.get(this.$url.selectStudentBehaviorList, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        // console.log("学生行为记录：", res);
        this.tableData = res.rows;
        this.total = res.total;
      })
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./studentExperience.scss";
</style>